module.exports = __webpack_public_path__ + "img/wxPay.aabc6ef9.png";